const CancelReasons = {
  MISTAKENLY_CREATED: 'Mistakenly Created',
  LACK_OF_WORK: 'Lack of Work',
  PRODUCTION_PRODUCT_DOWN: 'Production/Product Down',
  FILLED_ELSEWHERE: 'Filled Elsewhere',
};

module.exports = CancelReasons;
